import { render, staticRenderFns } from "./RuleList.vue?vue&type=template&id=924a9a88"
import script from "./RuleList.vue?vue&type=script&lang=ts"
export * from "./RuleList.vue?vue&type=script&lang=ts"
import style0 from "./RuleList.vue?vue&type=style&index=0&id=924a9a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports